import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import {configureStore} from "@reduxjs/toolkit"
import { Toaster } from "react-hot-toast";

import rootReducer from "./reducer";
import "./index.css";
import App from "./App";


const store = configureStore({
  reducer:rootReducer,
});

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <Provider store = {store}>
      <BrowserRouter>
          <App />
          <Toaster/>
        </BrowserRouter>
    </Provider>
  </React.StrictMode>
);
